<template>
    <div class="Driftwood">
      <h1>Driftwood</h1>
      <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/q4yFho5m7tg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      <p>
        In this project we had a lot of freedom in the gameplay, as it was our third C++ project using the 
        schools provided in house engine. I focused a lot on systems that required map editing in Tiled, 
        the external map editor we used. I made systems for switches and buttons that could be connected to events,
        moving platforms. 
      </p>
      <p>
        I also looked into and added support for pitching and reverb on sounds, which required me to
        look through the documentation of BASS, the audio library provided in the engine. This proved to be a bigger challenge
        than expected, as the interface and implementation of BASS was very difficult to understand, along with the 
        documentation being very minimal.
      </p>
    </div>
</template>

<style scoped>
.Driftwood{
  margin-left: 20%;
  margin-right: 20%;
}
</style>